import gql from "graphql-tag";
import { User } from "../baseTypes";
export default gql`
  query ListAllUsersWithGroups {
    listCognitoUsers(limit: 50) {
      items {
        username
        groups
        state
      }
    }
  }
`;
export interface ListAllUsersWithGroups {
  listCognitoUsers: {
    items: Array<User> | null;
  };
}
